<select class="in-out-picker" name="options" id="options">
  <option value="in">in</option>
  <option value="out">out</option>
</select>
